import React from "react";
import { useTranslation } from "react-i18next";

export const TableOfContentsTerms = () => {
  const { t } = useTranslation();

  return (
    <div className="text-14px md:text-[16px] leading-[25px] md:leading-[30px] gap-5">
      <h1 className="text-[18px] md:text-[20px] font-600 uppercase my-[20px]">
        {String(t("termsPage.table.title"))}
      </h1>
      <div>
        <ol className="uppercase font-600 list-auto flex flex-col gap-2 ml-[20px]">
          <li>
            <a href={`#our-services`} aria-label="our-services">
              {String(t("termsPage.table.t1"))}
            </a>
          </li>
          <li>
            <a
              href={`#intellectual-property-rights`}
              aria-label="intellectual-property-rights"
            >
              {String(t("termsPage.table.t2"))}
            </a>
          </li>
          <li>
            <a href={`#user-representations`} aria-label="user-representations">
              {String(t("termsPage.table.t3"))}
            </a>
          </li>
          <li>
            <a href={`#purchases-payment`} aria-label="purchases-payment">
              {String(t("termsPage.table.t4"))}
            </a>
          </li>
          <li>
            <a
              href={`#prohibited-activities`}
              aria-label="prohibited-activities"
            >
              {String(t("termsPage.table.t5"))}
            </a>
          </li>
          <li>
            <a href={`#third-party-content`} aria-label="third-party-content">
              {String(t("termsPage.table.t6"))}
            </a>
          </li>
          <li>
            <a href={`#services-management`} aria-label="services-management">
              {String(t("termsPage.table.t7"))}
            </a>
          </li>
          <li>
            <a href={`#privacy-policy`} aria-label="privacy-policy">
              {String(t("termsPage.table.t8"))}
            </a>
          </li>
          <li>
            <a href={`#term-termination`} aria-label="term-termination">
              {String(t("termsPage.table.t9"))}
            </a>
          </li>
          <li>
            <a
              href={`#modifications-interruptions`}
              aria-label="modifications-interruptions"
            >
              {String(t("termsPage.table.t10"))}
            </a>
          </li>
          <li>
            <a href={`#governing-law`} aria-label="governing-law">
              {String(t("termsPage.table.t11"))}
            </a>
          </li>
          <li>
            <a href={`#dispute-resolution`} aria-label="dispute-resolution">
              {String(t("termsPage.table.t12"))}
            </a>
          </li>
          <li>
            <a href={`#corrections`} aria-label="corrections">
              {String(t("termsPage.table.t13"))}
            </a>
          </li>
          <li>
            <a href={`#disclaimer`} aria-label="disclaimer">
              {String(t("termsPage.table.t14"))}
            </a>
          </li>
          <li>
            <a
              href={`#limitations-liability`}
              aria-label="limitations-liability"
            >
              {String(t("termsPage.table.t15"))}
            </a>
          </li>
          <li>
            <a href={`#indemnification`} aria-label="indemnification">
              {String(t("termsPage.table.t16"))}
            </a>
          </li>
          <li>
            <a href={`#user-data`} aria-label="user-data">
              {String(t("termsPage.table.t17"))}
            </a>
          </li>
          <li>
            <a
              href={`#electronic-communications`}
              aria-label="electronic-communications"
            >
              {String(t("termsPage.table.t18"))}
            </a>
          </li>
          <li>
            <a href={`#california-users`} aria-label="california-users">
              {String(t("termsPage.table.t19"))}
            </a>
          </li>
          <li>
            <a href={`#miscellaneous`} aria-label="miscellaneous">
              {String(t("termsPage.table.t20"))}
            </a>
          </li>
          <li>
            <a href={`#contact-us`} aria-label="contact-us">
              {String(t("termsPage.table.t21"))}
            </a>
          </li>
        </ol>
      </div>
    </div>
  );
};
